export default __webpack_public_path__ + "static/media/373.322623c3.png";